import { Component, Input, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { SasisopaService } from '../../../../../services/sasisopa.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as moment from 'moment';
import { getYearsForSelect } from '../../../../../helpers/utils';

type Row = {
  id: string;
  objective: string;
  alcalce: '';
  responsibilities: string;
  references: string;
  terms: string;
  development: string;
  changes: { code: string, name: string, speak: string }[];
  registers: {version: string, date: string, available: string, description: string, redacted: string}[];

}

const emptyForm: Row = {
  id: '',
  objective: '',
  alcalce: '',
  responsibilities: '',
  references: '',
  terms: '',
  development: '',
  changes: [],
  registers: [],
};

@Component({
  selector: 'ngx-formato-ocho-uno-sassisopa',
  templateUrl: './formato-ocho-uno-sassisopa.component.html',
})
export class FormatoOchoUnoSassisopaComponent implements OnInit {
  @Input() stationId: string;
  keyFormat='p_8_1'
  source: LocalDataSource;
  row = { ...emptyForm }
  loading = false
  year = moment().format('YYYY');
  years = getYearsForSelect();
  settings = {
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'download',
          title: '<img src="assets/images/icons/download.png" width="25px">',
        },
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.png" width="25px">',
        },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      objective: {
        title: 'Objetivo',
        filter: true,
      },
      responsibilities: {
        title: 'Responsabilidades',
        filter: true,
      },
      alcalce: {
        title: 'Alcance',
        filter: true,
      },
      references: {
        title: 'Referencias',
        filter: true,
      },

    },
    noDataMessage: 'Sin registros',
  };

  constructor(
    private readonly sasisopaService: SasisopaService,
  ) {}

  ngOnInit() {
    this.loadData()
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes.record?.currentValue?.rows) {
  //     this.source = new LocalDataSource(changes.record.currentValue.rows)
  //   }
  // }

  async loadData () {
    this.loading = true;
    this.row = { ...emptyForm };
    const [error, response] = await this.sasisopaService.getInfoProcedureNew(this.stationId, this.keyFormat, this.year);
    this.loading = false;
    if (error) {
      this.alert('Error al cargar los datos', 'error', error.message);
      return;
    }
    console.log('🚀 ~ FormatoDosUnoComponent ~ loadData ~ response:', response)
    this.source = new LocalDataSource(response.map(e => {
      e.data.id = e.id
      return { ...e, ...e.data }
    }))
  }

  async onCustom(event: { action: string; data: { data: any, id: string }; }) {
    this.row = event.data.data;
    this.row.id = event.data.id;
    if (event.action === 'delete') {
      // @ts-ignore
      $('#delete-document').modal('show');
    } else if (event.action === 'edit') {
      // @ts-ignore
      $('#create-document').modal('show');

    } else if (event.action === 'download') {
      this.download(this.row.id);
    }
  }

  async remove () {
    this.loading = true;
    const [error] = await this.sasisopaService.removeInfoProcedureNew(this.row.id);
    this.loading = false;
    if (error) {
      this.alert('Error al eliminar', 'error', error.message);
      return;
    }
    this.alert('Éxito', 'success', 'Operación realizada con éxito');
    this.loadData()
    // @ts-ignore
    $('#delete-document').modal('hide');
  }

  async storeOrUpdate () {
    this.loading = true;
    if (this.row.id) {
      const [error,] = await this.sasisopaService.updateInfoProcedureNew(
        this.row.id,
        { data: this.row }
      );
      this.loading = false;
      if (error) {
        this.alert('Error al guardar los datos', 'error', error.message);
        return;
      }
      this.loading = false;
    } else {
      const [error] = await this.sasisopaService.storeInfoProcedureNew(
        this.stationId,
        { data: this.row, year: this.year, key: this.keyFormat }
      );
      this.loading = false;
      if (error) {
        this.alert('Error al guardar los datos', 'error', error.message);
        return;
      }
    }
    this.alert('Éxito', 'success', 'Operación realizada con éxito');
    this.loadData()
    // @ts-ignore
    $('#create-document').modal('hide');
  }

  async download (modelId) {
    if (!modelId) return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde [model id not found]')
    await this.sasisopaService.downloadSasisopaFormat({
      stationId: this.stationId,
      procedure: '8',
      format: '1',
      year: this.year,
      modelId
    });
  }

  addChange() {
    this.row.changes.push({
      code: '',
      name: '',
      speak: ''
    });
  }

  removeChange(index: number) {
    this.row.changes.splice(index, 1);
  }

  // Funciones para la sección de Registros
  addRegister() {
    this.row.registers.push({
      version: '',
      date: '',
      available: '',
      description: '',
      redacted: ''
    });
  }

  removeRegister(index: number) {
    this.row.registers.splice(index, 1);
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
